// A lone CR must not be followed by LF, or one CRLF would read as two terminators.
const BLANK_LINE = /(?:\r\n|\r(?!\n)|\n){2}/
const LINE_BREAK = /\r\n|\r|\n/
const DATA_FIELD = 'data:'

export interface FrameParser {
  push: (chunk: string) => string[]
  flush: () => string[]
}

function dataOf(frame: string): string | null {
  const dataLines = frame
    .split(LINE_BREAK)
    .filter((line) => line.startsWith(DATA_FIELD))
    .map((line) => line.slice(DATA_FIELD.length).replace(/^ /, ''))
  return dataLines.length ? dataLines.join('\n') : null
}

/**
 * Splits a server-sent event byte stream into its decoded `data:` payloads. Comment lines
 * (a keepalive) produce no payload, and every line terminator the spec allows is accepted,
 * because a proxy may rewrite them and an unsplit stream would lose the terminal event.
 */
export function createFrameParser(): FrameParser {
  let buffer = ''

  function framesFrom(chunk: string, isFlush: boolean): string[] {
    buffer += chunk
    const frames = buffer.split(BLANK_LINE)
    buffer = isFlush ? '' : frames.pop() ?? ''
    return frames.map(dataOf).filter((data): data is string => data !== null)
  }

  return {
    push: (chunk) => framesFrom(chunk, false),
    // A stream that ends without a trailing blank line still holds a complete frame.
    flush: () => framesFrom('', true)
  }
}
